module.exports = __webpack_public_path__ + "img/1.269f2427.jpg";